import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { CheckCircle, Loader2, AlertCircle } from "lucide-react";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:4000/api";

export default function Unsubscribe() {
  const { token } = useParams<{ token: string }>();
  // `c` = id de la campaña de origen del enlace de baja (query param opaco,
  // ver send-service.ts). Se reenvía al backend para atribuir la baja a esa
  // campaña; si no viene, la baja funciona igual pero sin atribución.
  const [searchParams] = useSearchParams();
  const campaignId = searchParams.get("c");
  const campaignQs = campaignId ? `?c=${encodeURIComponent(campaignId)}` : "";
  const [status, setStatus] = useState<"loading" | "ok" | "error">("loading");
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    const run = async () => {
      try {
        const res = await fetch(
          `${API_URL}/public/unsubscribe/${token}${campaignQs}`,
          {
            headers: { Accept: "application/json" },
          },
        );
        if (!res.ok) {
          setStatus("error");
          setMessage("Enlace no válido o caducado");
          return;
        }
        setStatus("ok");
      } catch {
        setStatus("error");
        setMessage("Error de conexión");
      }
    };
    run();
  }, [token, campaignQs]);

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 to-cyan-50 p-4">
        <Loader2 className="w-10 h-10 animate-spin text-teal-600" />
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-rose-50 to-pink-50 p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <AlertCircle className="w-14 h-14 text-rose-500 mx-auto mb-4" />
          <h1 className="text-xl font-bold text-gray-900 mb-2">
            Enlace no válido
          </h1>
          <p className="text-gray-600">{message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 to-cyan-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        <CheckCircle className="w-16 h-16 text-emerald-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Te has dado de baja
        </h1>
        <p className="text-gray-600 mb-6">
          Ya no recibirás más emails ni WhatsApps de comunicaciones automáticas.
          Tus reservas y citas activas siguen vigentes.
        </p>
        <Link
          to={`/preferencias/${token}${campaignQs}`}
          className="inline-block px-6 py-2.5 bg-teal-600 hover:bg-teal-700 text-white rounded-lg font-medium transition-colors"
        >
          Gestionar mis preferencias
        </Link>
      </div>
    </div>
  );
}
